import React, { FC } from 'react';
import { TertiaryCtaProps } from './tertiaryCta.types';
import { StyledTertiaryCta } from './tertiaryCta.styles';
import { getSearchFormClickTrackingLoc } from '../../../../../../modules/utils/searchFormHelper';

const TertiaryCta: FC<TertiaryCtaProps> = ({ className, clickHandler, label }) => {
  return (
    <StyledTertiaryCta
      data-component-name="a-shop-TertiaryCta"
      data-testid="shop-TertiaryCta"
      type="button"
      className={`${className}`}
      onClick={clickHandler}
    >
      <span
        className="custom_click_track"
        {...{
          custom_click_track_value: `${getSearchFormClickTrackingLoc()}|  ${label} button |internal`,
        }}
      >
        {label}
      </span>
    </StyledTertiaryCta>
  );
};

export default TertiaryCta;
